module.exports = __webpack_public_path__ + "img/2024122502.28b1ca35.png";